import { PAYMENT_STATUS, TYPE_PAYMENT_METHOD } from 'helpers/constants'
import { IPaymentMethodFitter } from 'models'
import React, { useEffect, useState } from 'react'

interface PropsType {
  filter: IPaymentMethodFitter
  onFilter: Function
}
const FilterPaymentMethod = ({ onFilter, filter }: PropsType) => {
  const [filterValue, setFilterValue] = useState<IPaymentMethodFitter>(filter)
  const handleSubmit = (e: any) => {
    e.preventDefault()
    onFilter(filter)
  }

  useEffect(() => {
    setFilterValue(filter)
  }, [filter])
  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="card border-0 rounded" style={{ minWidth: '100%' }}>
          <div className="card-header rounded d-inline-block">
            <div className="row gx-1 align-items-end justify-content-end">
              <div className="col-md-2">
                <div className="row gx-1">
                  <div className="col-md mb-2">
                    <label className="lbl mb-1">Search Name </label>
                    <div className="d-flex align-items-center">
                      <div className="col">
                        <input
                          className="form-control border w-100"
                          type="text"
                          id="textid"
                          onChange={(e) => {
                            setFilterValue({
                              ...filterValue,
                              searchText: e.target.value,
                            })
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2">
                <div className="row gx-1">
                  <div className="col-md mb-2">
                    <label className="lbl mb-1">Type</label>
                    <div className="d-flex align-items-center">
                      <div className="col">
                        <select
                          className="form-select border w-100"
                          onChange={(filterChange: any) => {
                            setFilterValue({
                              ...filterValue,
                              type: filterChange.target.value,
                            })
                          }}
                        >
                          {TYPE_PAYMENT_METHOD.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2">
                <div className="row gx-1">
                  <div className="col-md mb-2">
                    <label className="lbl mb-1">Status</label>
                    <div className="d-flex align-items-center">
                      <div className="col">
                        <select
                          className="form-select border w-100"
                          onChange={(filterChange: any) => {
                            setFilterValue({
                              ...filterValue,
                              status: filterChange.target.value,
                            })
                          }}
                        >
                          {PAYMENT_STATUS.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.text}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-auto mb-2">
                <button
                  className="btn btn-primary btn-md border-0 px-4"
                  onClick={() => {
                    onFilter(filterValue)
                  }}
                >
                  <small>Search</small>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  )
}

export default FilterPaymentMethod
